import getJWTToken from "config/jwtToken";

const SUPER_USERS = [ 1, 2, 3, 4, 6, 20, 21, 23, 24 ];

export function isSuperUser() {
  const token = getJWTToken();
  const userId = Number(token?.decoded?.nameid);
  return SUPER_USERS.includes(userId);
}
